module.exports = __webpack_public_path__ + "header-ziggo.f7f1e923b8d332fb95bb.png";


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/assets/images/header-ziggo.png
// module id = ../../../../../src/assets/images/header-ziggo.png
// module chunks = styles